module.exports = __webpack_public_path__ + "img/business-consulting-2.746eafa9.png";